/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileStoreDetails } from './StoreProfileStoreDetails';
import {
    StoreProfileStoreDetailsFromJSON,
    StoreProfileStoreDetailsFromJSONTyped,
    StoreProfileStoreDetailsToJSON,
    StoreProfileStoreDetailsToJSONTyped,
} from './StoreProfileStoreDetails';

/**
 * 
 * @export
 * @interface StoreProfileChangeRequest
 */
export interface StoreProfileChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileChangeRequest
     */
    id: string;
    /**
     * 
     * @type {StoreProfileChangeRequestApprovalStatusEnum}
     * @memberof StoreProfileChangeRequest
     */
    approvalStatus?: StoreProfileChangeRequestApprovalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileChangeRequest
     */
    rejectionReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileChangeRequest
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileChangeRequest
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfileChangeRequest
     */
    storeProfileVisibleAfterApproval?: boolean;
    /**
     * 
     * @type {StoreProfileStoreDetails}
     * @memberof StoreProfileChangeRequest
     */
    store: StoreProfileStoreDetails;
}


/**
 * @export
 */
export const StoreProfileChangeRequestApprovalStatusEnum = {
    InReview: 'IN_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED'
} as const;
export type StoreProfileChangeRequestApprovalStatusEnum = typeof StoreProfileChangeRequestApprovalStatusEnum[keyof typeof StoreProfileChangeRequestApprovalStatusEnum];


/**
 * Check if a given object implements the StoreProfileChangeRequest interface.
 */
export function instanceOfStoreProfileChangeRequest(value: object): value is StoreProfileChangeRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function StoreProfileChangeRequestFromJSON(json: any): StoreProfileChangeRequest {
    return StoreProfileChangeRequestFromJSONTyped(json, false);
}

export function StoreProfileChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'approvalStatus': json['approvalStatus'] == null ? undefined : json['approvalStatus'],
        'rejectionReason': json['rejectionReason'] == null ? undefined : json['rejectionReason'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'storeProfileVisibleAfterApproval': json['storeProfileVisibleAfterApproval'] == null ? undefined : json['storeProfileVisibleAfterApproval'],
        'store': StoreProfileStoreDetailsFromJSON(json['store']),
    };
}

export function StoreProfileChangeRequestToJSON(json: any): StoreProfileChangeRequest {
    return StoreProfileChangeRequestToJSONTyped(json, false);
}

export function StoreProfileChangeRequestToJSONTyped(value?: StoreProfileChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'approvalStatus': value['approvalStatus'],
        'rejectionReason': value['rejectionReason'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'storeProfileVisibleAfterApproval': value['storeProfileVisibleAfterApproval'],
        'store': StoreProfileStoreDetailsToJSON(value['store']),
    };
}

